import client from './client';
import { HomeVideo } from '../components/public/HomeSections';

export const getHomeVideos = async (): Promise<HomeVideo[]> => {
    const response = await client.get<HomeVideo[]>('/admin/top-video');
    return Array.isArray(response.data) ? response.data : [];
};
